module.exports = __webpack_public_path__ + "static/media/logo.1d8038b4.svg";